import { BlurredProBanner } from 'components/OrganizationPageBody/components/OrganizationData/components/BlurredProBanner';
import { blurredVotingTokenContent } from '../../../../constants';
import React, { FC } from 'react';

type ProBlurComponentProps = {
    title?: string;
    showBlurredContent?: boolean;
    description?: string;
};
export const ProBlurComponent: FC<ProBlurComponentProps> = ({
    title = 'Token is a DeepDAO Pro feature',
    description = 'Upgrade to Pro to access detailed token analytics and voting data',
    showBlurredContent = true,
}) => {
    return (
        <div>
            <BlurredProBanner title={title} description={description}>
                {showBlurredContent && blurredVotingTokenContent}
            </BlurredProBanner>
        </div>
    );
};
